import { render } from "./CommitHistory.vue?vue&type=template&id=197f5198&scoped=true&ts=true"
import script from "./CommitHistory.vue?vue&type=script&lang=ts"
export * from "./CommitHistory.vue?vue&type=script&lang=ts"

import "./CommitHistory.vue?vue&type=style&index=0&id=197f5198&scoped=true&lang=scss"
import "./CommitHistory.vue?vue&type=style&index=1&id=197f5198&lang=scss"

import exportComponent from "/Users/lihui/Desktop/project/student_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197f5198"]])

export default __exports__